import { ReactComponent as UserOctagon } from '../../components/icons/user-octagon.svg';

export const getHeaders = () => [
  <div className="table-columns-headers">
    <div>ID</div>
  </div>,
  <div className="table-columns-headers">
    <div>Zgłoszone przez</div>
  </div>,
  <div className="table-columns-headers">
    <div>Zgłoszony użytkownik</div>
  </div>,
  <div className="table-columns-headers">
    <div>Opis zgłoszenia</div>
  </div>,
  <div className="table-columns-headers">
    <div>Powiązane treści</div>
  </div>,
  <div className="table-columns-headers">
    <div>Data zgłoszenia</div>
  </div>,
  <div className="table-columns-headers">
    <div>Akcje</div>
  </div>,
];

export const headerWidths = ['90px', '1fr', '1fr', '1fr', '3fr', '170px', '180px'];

export const tabsConfig = () => [
  {
    icon: UserOctagon,
    name: 'Zgłoszeni użytkownicy',
    hoverClass: 'hover-effect',
    activeClass: 'is-active',
    onClick: () => {},
    toggleActive: true,
  },
];

export const empty = [];
